module.exports = __webpack_public_path__ + "static/img/icons_fixed_margin_blue.31e8840.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/menu-icons/icons_fixed_margin_blue.svg
// module id = rJuo
// module chunks = 1